import React, { useEffect, useState } from 'react'
import { ImageBackground } from 'react-native'

import { useRoute } from '@react-navigation/native'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B4, BTN, H6, Icon } from '@zet/design-system'
import { Stack, XStack, YStack } from '@zet/design-system/layout'
import { i18n } from '@zet/feature-credit-score/localization'
import { useComponentInitialMount } from '@zet/homepage-widgets/src/hooks/useComponentInitialMount'
import LottieView from 'lottie-react-native'

import { creditScoreIMG, creditScoreLottie } from '../../assets'
import CreditScoreBottomSheet from './creditScoreBottomSheet'

const HomePageCreditScoreCard = () => {
  const { params } = useRoute()
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false)
  const { setParams } = useNavigation()

  useEffect(() => {
    if (params?.isCreditScore) {
      setIsBottomSheetVisible(!!params?.isCreditScore)
    }
    return () => setParams({ isCreditScore: false })
  }, [params?.isCreditScore, setParams])

  useComponentInitialMount({
    componentName: 'HomePageCreditScoreCard',
    hasLoaded: true,
  })

  const handleButtonPress = () => {
    setIsBottomSheetVisible(true)
  }

  const onDismiss = () => {
    setIsBottomSheetVisible(false)
  }
  return (
    <YStack>
      <PressableWithIntent
        className="bg-neutral-background10"
        onPress={handleButtonPress}
        eventName="click_action"
        eventPayload={{ item_name: 'homepage_new_credit_score' }}
        name="CreditScoreCheck"
      >
        <ImageBackground
          source={creditScoreIMG}
          className="bg-neutral-white100 m-3 flex-row justify-between rounded-lg"
          imageStyle={{ borderRadius: 8, flex: 1 }}
        >
          <Stack className="justify-center pl-3" style={{ flex: 0.5 }}>
            <XStack className="bg-decorative-purple10 my-3 w-[175] items-center space-x-1 rounded py-1 pl-2">
              <Stack>
                <Icon type="GrowOutlined" size={20} />
              </Stack>
              <B4 className="text-[#310C44]">
                {i18n.t('checkCreditScore.growCustomer')}
              </B4>
            </XStack>
            <H6 className="w-[190] pb-3">
              {i18n.t('checkCreditScore.heading')}
            </H6>
            <Stack className="bg-primary-100 mb-3 w-[100] rounded-md py-2">
              <BTN className="text-center text-white">
                {i18n.t('checkCreditScore.cta')}
              </BTN>
            </Stack>
          </Stack>
          <Stack className="relative -top-1" style={{ flex: 0.5 }}>
            <LottieView
              autoPlay
              source={creditScoreLottie}
              className="h-[190]"
            />
          </Stack>
        </ImageBackground>
      </PressableWithIntent>
      {isBottomSheetVisible && (
        <CreditScoreBottomSheet
          visible={isBottomSheetVisible}
          onDismiss={onDismiss}
        />
      )}
    </YStack>
  )
}

export default React.memo(HomePageCreditScoreCard)
